export default "__VITE_ASSET__sjvajNCl__"